import { FormEvent, useState } from 'react';

import {
  Alert,
  AlertIcon,
  Box,
  Button,
  FormControl,
  Input,
  Text,
} from '@chakra-ui/react';

import { Link } from '@r-client/shared/ui/core';

export interface ILoginFormSubmitProps {
  email: string;
  password: string;
}

export interface ILoginFormProps {
  onSubmit: ({ email, password }: ILoginFormSubmitProps) => void;
  errorMessage?: string;
}

export const LoginForm = ({ onSubmit, errorMessage }: ILoginFormProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit({ email, password });
  };
  return (
    <Box>
      {!!errorMessage && (
        <Alert m="16px 0" status="error" borderRadius="md" fontSize="sm">
          <AlertIcon />
          {errorMessage}
        </Alert>
      )}
      <form onSubmit={handleFormSubmit}>
        <FormControl isRequired my="4">
          <Input
            type="email"
            id="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>
        <FormControl isRequired my="4">
          <Input
            type="password"
            id="password"
            placeholder="Password"
            minLength={8}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>
        <Box textAlign="right" mt="4">
          <Link href="/">
            <Text fontSize="md" color="brand.primary">
              Forgot password?
            </Text>
          </Link>
        </Box>
        <Button
          color="white"
          variant="primary"
          type="submit"
          mt="4"
          width="full"
        >
          Log in
        </Button>
      </form>
    </Box>
  );
};
